import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { UserStammdaten } from '../../entities/stammdaten.js';
import type { RegistrationStammdatenPlugin } from '../plugin-types.js';

// ===== Schnuppertage =====

export const stRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::st',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new STStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(STStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => STStammdaten,
};

export enum STJahrgangsstufeEnum {
  ST_Q1 = 'ST_Q1',
  ST_Q2 = 'ST_Q2',
  ST_Q3 = 'ST_Q3',
  ST_Q4 = 'ST_Q4',
  ST_SONSTIGES = 'ST_SONSTIGES',
}
registerEnum({ enum: STJahrgangsstufeEnum, name: 'STJahrgangsstufeEnum' });

@Entity()
export class STStammdaten extends UserStammdaten {
  static override _class = 'STStammdaten';

  override getTranslationNamespace() {
    return 'st';
  }

  @Field(type => String)
  nameDerSchule: Maybe<string>;

  @Field(type => STJahrgangsstufeEnum)
  jahrgangsstufequalifizierungsphase: Maybe<STJahrgangsstufeEnum>;

  @Field(type => Int)
  age: Maybe<number>;
}
